export default {
  name: 'ConfigEmailsMailMessageListExpand',
  props: {
    data: Object
  }
}
